import { Box, getColor, Typography, useToast } from "fds";
import "../index.scss";
import utilsCommon from "../../../shared/utils/common";
import { useNavigate } from "react-router-dom";
import LoadingCircle from "../../../components/Icons/LoadingCircle";
import { useEffect, useState } from "react";
import useLoginStore from "../../../redux/dispatcher/useLoginStore";
import { nanoid } from "@reduxjs/toolkit";
import { t } from "i18next";
import { ActionResponse } from "../../../types/auth";
import useStartDownload from "../../../shared/hooks/useStartDownload";
import useDocumentStore from "../../../redux/dispatcher/useDocumentStore";
const DownloadIng = ({
  uid,
  otp,
  actionInfo,
}: {
  uid: string;
  otp?: string;
  actionInfo: ActionResponse;
}) => {
  /** Hook 정리 */
  const navigate = useNavigate();
  const toasts = useToast();
  const { getFileUrlDownloadFromUid, getDocHtmlDownload } = useLoginStore();
  const { getContentDownload } = useDocumentStore();
  const startDownload = useStartDownload();

  /** State 정리 */
  const [status, changeStatus] = useState("WAITING"); // 현재 링크 상태

  /** UseEffect정리 */
  useEffect(() => {
    if (uid) {
      changeStatus("WAITING");
      actionInfo.authType === "LOGIN"
        ? getContentDownload({
            syncId: actionInfo.syncId,
            revisionNo: (actionInfo.revisionNo ?? 0) + "",
            startDownload: startDownload,
          })
            .then((result: any) => {
              changeStatus("START");
              if (result.error) {
                changeStatus("ERROR");
                if (
                  result.error.name &&
                  result.error.name !== "INTERNAL_SERVER_ERROR"
                ) {
                  toasts.toastMsg(nanoid(), result.error.message, "error");
                } else {
                  toasts.toastMsg(
                    nanoid(),
                    t("file.alert.downloadFail"),
                    "error"
                  );
                }
              }
            })
            .catch((err) => changeStatus("ERROR"))
        : actionInfo.urlAction === "DOWNLOAD"
        ? getFileUrlDownloadFromUid({ uid: uid, token: otp })
            .then((result: any) => {
              changeStatus("START");
              if (result.error) {
                changeStatus("ERROR");
                if (
                  result.error.name &&
                  result.error.name !== "INTERNAL_SERVER_ERROR"
                ) {
                  toasts.toastMsg(nanoid(), result.error.message, "error");
                } else {
                  toasts.toastMsg(
                    nanoid(),
                    t("file.alert.downloadFail"),
                    "error"
                  );
                }
              }
            })
            .catch((err) => changeStatus("ERROR"))
        : getDocHtmlDownload({
            uid: uid,
            syncId: actionInfo.syncId,
            revisionNo: actionInfo.revisionNo.toString(),
            startDownload: startDownload,
          })
            .then((result: any) => {
              changeStatus("START");
              if (result.error) {
                changeStatus("ERROR");
                if (
                  result.error.name &&
                  result.error.name !== "INTERNAL_SERVER_ERROR"
                ) {
                  toasts.toastMsg(nanoid(), result.error.message, "error");
                } else {
                  toasts.toastMsg(
                    nanoid(),
                    t("file.alert.downloadFail"),
                    "error"
                  );
                }
              }
            })
            .catch((err) => changeStatus("ERROR"));
    }
  }, [uid]);

  return (
    <Box height={"100%"} width={"100%"} direction="column" alignItems="center">
      <Box classes="error-header">
        <img
          src={utilsCommon.renderWrapsodyECOLogo()}
          alt={"logo"}
          height={46}
          className="cursor pointer"
          onClick={() => navigate(`${process.env.PUBLIC_URL}/home`)}
        />
      </Box>
      <Box height={120} />
      {status === "WAITING" ? (
        <Box direction="column" alignItems="center">
          <LoadingCircle />
          <Typography type="h2" classes="mg mt-32">
            {t("uidLink.downloading")}
          </Typography>
          <Typography
            type="body2_rg"
            classes="mg mt-20"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("uidLink.downloadDesc")}
          </Typography>
        </Box>
      ) : (
        <Box direction="column" alignItems="center" width={350}>
          <img
            src={require("../../../shared/images/pages/File/download.png")}
            alt="download"
          />
          <Typography type="h2" classes="mg mt-32">
            {status === "ERROR"
              ? t("uidLink.downloadFail")
              : t("uidLink.downloadStart")}
          </Typography>
          {status !== "ERROR" && (
            <Typography
              type="body2_rg"
              classes="mg mt-20"
              whiteSpace="break-spaces"
              textAlign="center"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("uidLink.downloadStartDesc")}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default DownloadIng;
